import type { SearchResult } from "@mirage/service-dbx-api";

/**
 * Determine whether the provided SearchResult refers to a PDF document.
 *
 * This check is intentionally very simple and we avoid MIME-type detection here because SearchResult.mimeType
 * is often undefined for external links.
 */
export const isPdfFile = ({
  url,
  title,
}: Pick<SearchResult, "url" | "title">): boolean => {
  if (url) {
    try {
      const pathname = new URL(url).pathname.toLowerCase();
      if (pathname.endsWith(".pdf") || pathname.includes(".pdf")) {
        return true;
      }
    } catch {
      // fall back to title check
    }
  }

  return (title ?? "").toLowerCase().endsWith(".pdf");
};
